import { render } from "./Overview.vue?vue&type=template&id=a7989774"
import script from "./Overview.vue?vue&type=script&lang=ts"
export * from "./Overview.vue?vue&type=script&lang=ts"
script.render = render

export default script